import { HeaderService } from 'src/app/_services/header.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CompanyBasic } from 'src/app/app/company/company.model';
import { CompanyService } from 'src/app/app/company/company.service';
import { DictionaryService } from 'src/app/dictionary/dictionary.service';
import { AuthService } from 'src/app/public/auth/auth.service';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { customValidators } from 'src/app/_helpers/customValidators';
import { globalHelper } from 'src/app/_helpers/global';
import { User, UserRole } from 'src/app/_models/user.model';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { RowsLoaderService } from 'src/app/_services/rows-loader.service';
import { TranslateConfigService } from 'src/app/_services/translate-config.service';
import { UserService } from 'src/app/_services/user.service';
import { CompanyGroupViewComponent } from '../../company/group/company-group-view/company-group-view.component';
import {
  CompanyGroup,
  CompanyGroupType,
} from '../../company/group/gorup.model';
import { CompanyGroupService } from '../../company/group/group-service';
import { PaginationClientSideOptions } from '../../_component/pagination-client-side/pagination-client-side-options';
import { PaginationColumn } from '../../_component/pagination-client-side/pagination-column.class';
import { AddUserDepartmentPage } from '../add-user-department/add-user-department.page';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.page.html',
  styleUrls: ['./edit-user.page.scss', './../../../_styles/ion-grid-box.scss'],
})
export class EditUserPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    public userServ: UserService,
    public authenticationService: AuthService,
    private router: Router,
    private loadingCtrl: LoadingController,
    public companyServ: CompanyService,
    private translateServ: TranslateService,
    public p: ThisPlatform,
    private el: ElementRef,
    public alertController: AlertController,
    public dictionaryServ: DictionaryService,
    public modalCtrl: ModalController,
    public companyGroupServ: CompanyGroupService,
    private translateConfigService: TranslateConfigService,
    private authService: AuthenticationService,
    private popoverController: PopoverController,
    private headerServ: HeaderService
  ) { }

  validationError = false;
  form: FormGroup;
  passwordEye = false;
  disabledChangeCompany = true;
  loading = true;
  errorMessage: string = '';
  user: User;
  userId: number;
  userCompany: CompanyBasic = new CompanyBasic();
  disableSaveButton: boolean = false;
  currentRole: UserRole;

  isError: boolean = false;
  errorStatus: number;

  headerInit: HeaderModel = {
    title: '',
    backDefaultHref: '/app/users',
    showRightButtonsOnlyOnMobile: true,
  };

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    mainStyle: 'gray-md-rows',
    gridColumnsCount: 13,
    mobileViewBreakPoint: 1360,
    removeElementAction: this.DepartmentDelete(),
    headerEmitClick: true,
  };

  departmentsColumns: PaginationColumn[] = [
    {
      name: 'name',
      displayName: 'NAME',
      size: 6,
      sortable: true,
    },
    {
      name: 'description',
      displayName: 'DESCRIPTION',
      size: 6,
      sortable: true,
      colValue: (row) => {
        return row.description;
      },
    },
  ];
  rowsLoader: RowsLoaderService;
  componentRef: any = CompanyGroupViewComponent;
  emailValitators = [];
  enterFromLink: boolean;

  async ngOnInit() {
    this.companyServ.loadCompaniesSync('true', true);
    await this.userServ.loadRolesSync();
    this.userServ.userGroupDeparments = [];
    this.userServ.user = new User();
    this.userServ.user.idCompany = this.userServ.userStorage.idCompany;

    this.route.paramMap.subscribe(async (paramMap) => {
      if (paramMap.has('UserId')) {
        this.initForm(false);

        this.headerInit.title = this.translateServ.instant('USERS.EDIT_USER');
        this.headerInit.rightButtons = [
          {
            iconName: 'trash',
            rolePermission: ['user.edit'],
            onClick: () => this.onDeleteUser(),
          },
        ];

        this.userId = Number(paramMap.get('UserId'));

        this.form.get('password').setValidators(null);
        this.form.get('password').updateValueAndValidity();

        this.getUser();

        this.enterFromLink = true;

        this.options.permissionSpaceAdd = await this.userServ.hasRolesAsync([
          'user.edit',
        ]);
      } else {
        this.headerInit.title = this.translateServ.instant('USERS.NEW_USER');
        this.headerInit.rightButtons = null;
        this.initForm(true);
        this.enterFromLink = false;
        this.user.visibleInVirtualReception = false;
      }
    });
    this.headerServ.setHeaderInit(this.headerInit);
    this.loading = false;
  }

  initForm(emailRequied: boolean) {
    let emailValitators = [Validators.maxLength(255), Validators.required];

    if (emailRequied) {
      emailValitators.push(customValidators.emailPattern);
    } else {
      emailValitators.push(customValidators.trimValidator());
    }

    this.form = new FormGroup({
      email: new FormControl('', {
        updateOn: 'blur',
        validators: emailValitators,
      }),
      password: new FormControl('', {
        updateOn: 'blur',
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(30),
        ],
      }),
      firstName: new FormControl('', {
        updateOn: 'blur',
        validators: [
          Validators.required,
          Validators.maxLength(50),
          customValidators.trimValidator(),
        ],
      }),
      lastName: new FormControl('', {
        updateOn: 'blur',
        validators: [
          Validators.required,
          Validators.maxLength(50),
          customValidators.trimValidator(),
        ],
      }),
      telephone: new FormControl('', {
        updateOn: 'blur',
        validators: [
          customValidators.phoneNumberPattern,
          Validators.maxLength(15),
          customValidators.maxLengthWithoutWhiteSpacesValidator(15),
          Validators.minLength(9),
        ],
      }),
      mobilePhone: new FormControl('', {
        updateOn: 'blur',
        validators: [
          customValidators.phoneNumberPattern,
          Validators.minLength(9),
          Validators.maxLength(15),
          customValidators.maxLengthWithoutWhiteSpacesValidator(15),
        ],
      }),
      carPlate: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.maxLength(15)],
      }),
      company: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
      idBuilding: new FormControl('', {
        updateOn: 'blur',
      }),
      idRole: new FormControl('', {
        updateOn: 'blur',
        validators: [Validators.required],
      }),
      reception: new FormControl(false, {
        updateOn: 'blur',
      }),
      visibleInVirtualReception: new FormControl(false, {
        updateOn: 'blur',
      }),
      itemImage: new FormControl(null, {
        updateOn: 'blur',
        validators: [
          customValidators.fileMaxSize(10000000),
          customValidators.fileFormat([
            'jpg',
            'png',
            'gif',
            'jfif',
            'pjpeg',
            'jpeg',
            'pjp',
          ]),
        ],
      }),
      status: new FormControl(null),
      activated: new FormControl(false),
    });
  }

  async getUser() {
    const user = await this.userServ.getUserSync(this.userId).catch((err) => {
      this.isError = true;
      this.errorStatus = err.status;
      this.loading = false;
    });
    if (user) {
      this.user = user;
      this.departmentRefresh();
    }

    this.currentRole = this.userServ.checkRole(this.user.idRole);

    if (this.userServ.user.idCompany) {
      this.userCompany = await this.companyServ.getCompanySync(
        this.userServ.user.idCompany
      );
    }

    if (this.userServ.user.idRole) {
      this.userServ.user.role = this.userServ.userRoles.find(
        (a) => a.id === this.userServ.user.idRole
      );
    }
    this.form.patchValue({
      email: this.user.email,
      username: this.user.username,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      telephone: this.user.telephone,
      mobilePhone: this.user.mobilePhone,
      company: await this.companyServ.findCompany(this.user.idCompany),
      idRole: this.currentRole,
      carPlate: this.user.carPlate,
      reception: this.user.reception,
      itemImage: this.user.avatar,
      status: this.user.status,
      visibleInVirtualReception: this.user.visibleInVirtualReception,
      activated: this.user.activated,
    });

    this.loading = false;
  }

  departmentRefresh() {
    if (this.userId) {
      this.companyGroupServ
        .getCompanyGroups(
          this.user.idCompany,
          CompanyGroupType.Department,
          this.userId
        )
        .subscribe((res: CompanyGroup[]) => {
          this.userServ.userGroupDeparments = res;
          this.rowsLoaderInit();
        });
    }
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      this.rowsLoader.init(this.userServ.userGroupDeparments);
    }
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
    this.departmentRefresh();
  }

  Save() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }

    this.disableSaveButton = true;

    const formData = new FormData();
    const formValue = this.form.value;

    formData.append('email', formValue.email);
    formData.append('username', formValue.email);
    formData.append('password', formValue.password);
    formData.append('firstName', formValue.firstName);
    formData.append('lastName', formValue.lastName);
    formData.append(
      'telephone',
      formValue.telephone ? formValue.telephone.replace(/\s/g, '') : ''
    );
    formData.append(
      'mobilePhone',
      formValue.mobilePhone ? formValue.mobilePhone.replace(/\s/g, '') : ''
    );
    formData.append(
      'idCompany',
      formValue.company.id ? formValue.company.id : ''
    );
    formData.append('carPlate', formValue.carPlate ? formValue.carPlate : '');
    formData.append('idRole', formValue.idRole ? formValue.idRole.id : '');
    formData.append(
      'reception',
      formValue.reception ? formValue.reception : ''
    );
    formData.append(
      'visibleInVirtualReception',
      formValue.visibleInVirtualReception
        ? formValue.visibleInVirtualReception
        : ''
    );

    if (formValue.itemImage) {
      formData.append('file', formValue.itemImage);
    } else {
      formData.append('deleteAvatar', 'true');
    }

    // Aktywacja konta dodanego z poziomu aplikacji
    if (!this.user?.activated) {
      formData.append('activated', formValue.activated);
      formData.append(
        'status',
        formValue.activated ? formValue.activated : formValue.status
      );
    } else {
      formData.append('status', formValue.status);
    }

    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: this.translateServ.instant('SAVING'),
      })
      .then((loadingEl) => {
        loadingEl.present();

        if (this.userId) {
          this.userServ.updateUser(formData, this.userId).subscribe(
            (user) => {
              loadingEl.dismiss();
              this.disableSaveButton = false;
              this.updateCurrentUser(this.userId, user);
              this.back();
            },
            (error) => {
              loadingEl.dismiss();
              this.errorMessage = this.userErrorMessage(error.error.code);
              this.disableSaveButton = false;
            }
          );
        } else {
          this.userServ.createUser(formData).subscribe(
            () => {
              loadingEl.dismiss();
              this.back();
            },
            (error) => {
              loadingEl.dismiss();
              this.errorMessage = this.userErrorMessage(error.error.code);
              this.disableSaveButton = false;
            }
          );
        }
      });
  }

  updateCurrentUser(id, user) {
    let userStorage: User = JSON.parse(localStorage.getItem('currentUser'));
    let userStorageNew: User;

    if (userStorage.id == id) {
      userStorageNew = {
        ...userStorage,
        ...user,
      };

      localStorage.setItem('currentUser', JSON.stringify(userStorageNew));
      this.authService.currentUserSubject.next(userStorageNew);
      this.translateConfigService.setLanguage(user.language);
    }
  }

  // compareWithFn(o1, o2) {
  //   return o1 === o2;
  // }

  backToUsersList() {
    this.router.navigate(['/app/users']);
  }

  userErrorMessage(code: number) {
    switch (code) {
      case 1:
        return 'USERS.ERROR.ACCOUNT_EXISTS';
      case 2:
        return 'USERS.ERROR.USERNAME_EXISTS';
    }
  }

  passwordEyeAction() {
    this.passwordEye = !this.passwordEye;
  }

  async onDeleteUser() {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateServ
    );
    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateServ.instant('DELETING'),
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.userServ.delete(this.userId).subscribe(() => {
            loadingEl.dismiss();
            this.router.navigateByUrl('/app/users');
          });
        });
    }
  }

  async addDepartment() {
    const modal = await this.modalCtrl.create({
      component: AddUserDepartmentPage,
      animated: true,
      cssClass: 'add-edit-modal add-edit-modal--edit-parking-space',
      componentProps: {
        userId: this.userId,
        companyId: this.user.idCompany,
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.role !== 'backdrop') {
        this.departmentRefresh();
      }
    });
    modal.present();
  }

  handleActionRequest(action) {
    if (action.type === 'remove') {
      this.DepartmentDelete()(action.id);
    }
  }

  DepartmentDelete() {
    return async (idCompanyGroup: number) => {
      const alert = await this.alertController.create({
        header: this.translateServ.instant('CONFIRM'),
        message: this.translateServ.instant('QUESTION_DELETE'),
        buttons: [
          {
            text: this.translateServ.instant('CANCEL'),
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => { },
          },
          {
            text: 'Ok',
            handler: () => {
              this.companyGroupServ
                .deleteCompanyGroupUser(
                  idCompanyGroup,
                  this.user.idCompany,
                  this.user.id
                )
                .subscribe(() => {
                  this.departmentRefresh();
                });
            },
          },
        ],
      });

      await alert.present();
    };
  }

  back(): void {
    if (this.userServ.lastSegment) {
      this.router.navigateByUrl(
        '/app/users?section=' + this.userServ.lastSegment
      );
    } else {
      this.router.navigate(['/app/users']);
    }
  }
  onSelectTouched(formControlName: string): void {
    this.form.get(formControlName).markAsTouched();
  }

  async onShowPopover(event: Event) {
    const popover = await globalHelper.Popover(
      this.popoverController,
      event,
      [],
      'user-assignment-view-share__popover',
      'USERS.DISABLED_CHANGE_COMPANY_INFO'
    );
  }

  onChangeCompany($event) {
    this.user.idCompany = $event.id;
  }

  selectedStatusChange(value: number) {
    this.form.patchValue({
      status: value,
    });
  }

  selectedActivationChange(value: number) {
    this.form.patchValue({
      activated: value,
    });
  }
}
